// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ns-date-picker-wrapper.v-menu__content.menuable__content__active{border-top:1px solid!important;border-radius:0}.v-date-picker-table .v-btn.v-btn--active{color:#252525}", ""]);
// Exports
module.exports = exports;
